export default "__VITE_ASSET__f0142571__"